import React from 'react';

// Generic, reusable HowTo structured data component.
// Pass name/description/url explicitly for each page that uses it — the
// defaults below exist only so any pre-existing call site without those
// props keeps rendering sensible schema.
const HowToSchema = ({
  steps,
  name = 'How to Get Professional CAD Floor Plans from Your Sketch',
  description = 'Step-by-step guide to converting your floor plan sketch into professional CAD plans with House Plan Direct',
  url = 'https://houseplandirect.com/how-it-works',
  totalTime,
  estimatedCost,
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": name,
    "description": description,
    ...(totalTime ? { "totalTime": totalTime } : {}),
    ...(estimatedCost ? { "estimatedCost": { "@type": "MonetaryAmount", "currency": "GBP", "value": String(estimatedCost) } } : {}),
    "step": steps.map((step, index) => ({
      "@type": "HowToStep",
      "position": index + 1,
      "name": step.name,
      "text": step.text,
      "url": `${url}#step-${index + 1}`
    }))
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default HowToSchema;
